import { render, staticRenderFns } from "./AdsMetricsWizard.vue?vue&type=template&id=46895a2c&scoped=true&"
import script from "./AdsMetricsWizard.vue?vue&type=script&lang=js&"
export * from "./AdsMetricsWizard.vue?vue&type=script&lang=js&"
import style0 from "./AdsMetricsWizard.vue?vue&type=style&index=0&id=46895a2c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46895a2c",
  null
  
)

export default component.exports